import { Flex, PasswordInput } from '@inflearn/ds-react';
import type { MantineSize } from '@mantine/core';
import _ from 'lodash-es';
import { useTranslation } from 'next-i18next';
import type { FieldErrors, UseFormRegister } from 'react-hook-form';

import { usePasswordValidation } from '../../../../../hooks/usePasswordValidation';
import ValidationMessage from '../../../../common/ValidationMessage';

export interface PasswordFormValue {
  password: string;
  passwordConfirm: string;
}

export type PasswordVerifyFormItemsProps<T> = T extends PasswordFormValue
  ? {
      register: UseFormRegister<T>;
      errors: FieldErrors<T>;
      size?: MantineSize;
    }
  : never;

export const PasswordVerifyFormItems = <T extends PasswordFormValue>({
  register,
  errors,
  size = 'md',
}: PasswordVerifyFormItemsProps<T>) => {
  const { t } = useTranslation();
  const { onValidate, validationMessages } = usePasswordValidation();

  return (
    <>
      <Flex direction="column" gap={5}>
        <PasswordInput
          {...register('password')}
          onChange={(e) => {
            /** 공백 제외 */
            e.target.value = e.target.value.replace(/\s/g, '');
            register('password').onChange(e);
            onValidate(e.target.value);
          }}
          size={size}
          label={t('비밀번호')}
          placeholder="********"
          error={!_.isUndefined(errors.password?.message)}
        />

        <Flex direction="column" gap={4}>
          {validationMessages.map(({ type, message, status }) => (
            <ValidationMessage key={type} message={message} status={status} />
          ))}
        </Flex>
      </Flex>
      <PasswordInput
        {...register('passwordConfirm')}
        size={size}
        label={t('비밀번호 확인')}
        placeholder="********"
        error={
          errors.passwordConfirm?.message && (
            <ValidationMessage message={errors.passwordConfirm.message} />
          )
        }
      />
    </>
  );
};
